import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDropboxRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 31 31",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#0061ff",
		d: "M15.3 9 9 13l6.3 4L9 21l-6.3-4L9 13 2.7 9 9 5zM9 22.1l6.3-4 6.2 4-6.2 4zm6.3-5.3 6.3-4-6.3-4 6.2-4 6.3 4-6.3 4 6.3 4-6.3 4z"
	})
});
export default SvgDropboxRegularIcon;
